{
  "baseSpeedPxPerSec": 300,
  "gravityPxPerSec2": 2400,
  "jumpVelocityPxPerSec": 820,
  "doubleJumpVelocityPxPerSec": 700,
  "jumpReleaseKeepPct": 45,
  "maxFallSpeedPxPerSec": 1200,
  "coyoteMs": 80,
  "jumpBufferMs": 100,
  "playerWidthPx": 28,
  "playerHeightPx": 48,
  "rampSnapPx": 8,
  "mudSpeedPct": 70,
  "slowStripPct": 60,
  "bounceVelocityPxPerSec": 1300,
  "speedStripMs": 1000,
  "speedStripSpeedPct": 40,
  "crumbleDelayMs": 600,
  "crumbleRespawnMs": 3000,
  "tumbleSpeedPct": 30,
  "tumblePopVelocityPxPerSec": 450,
  "postStunInvulnMs": 1000,
  "respawnDelayMs": 1500,
  "respawnInvulnMs": 1500,
  "finishRunoutPx": 480,
  "startSpacingPx": 32,
  "countdownMs": 3000,
  "match": {
    "startFullMs": 1000,
    "startMultiMs": 5000,
    "startSoloMs": 10000,
    "finishGraceMs": 10000,
    "raceCapMs": 180000,
    "resultsHoldMs": 30000,
    "botTakeoverMs": 3000,
    "reconnectMs": 20000
  },
  "hazards": {
    "bladeStunMs": 1200,
    "bladeTipSizePx": 40,
    "spikeStunMs": 1000,
    "spikeTelegraphMs": 600,
    "spikeHeightPx": 16,
    "fallingBlockStunMs": 1500,
    "fallingBlockTelegraphMs": 800,
    "fallingBlockRestMs": 1000,
    "stakeStunMs": 1000,
    "stakeHeightPx": 48,
    "spikedStoneStunMs": 1000,
    "spikedStoneSizePx": 40,
    "trapdoorStunMs": 1200,
    "trapdoorTelegraphMs": 600,
    "trapdoorSprungMs": 500,
    "trapdoorStakeHeightPx": 48,
    "barrelSpeedPxPerSec": 240,
    "barrelSizePx": 40,
    "barrelTelegraphMs": 600,
    "barrelStunMs": 1000
  },
  "bots": {
    "tier1": {
      "lookaheadPx": 220,
      "reactionMinMs": 120,
      "reactionMaxMs": 250,
      "itemDelayMinMs": 500,
      "itemDelayMaxMs": 2000,
      "trapWhenRankAtMost": 2,
      "actEarlyMaxTicks": 6,
      "lateChancePct": 8,
      "lateMinTicks": 2,
      "lateMaxTicks": 4,
      "upperRouteMinPct": 30,
      "upperRouteMaxPct": 70,
      "climbMinPx": 48,
      "dropAvoidPx": 128,
      "missileMinLeadMs": 1000
    }
  }
}
